<template>
  <div class="column-flex-container">
    <h1>Belépés</h1>
    <b-form>
      <b-form-input
        id="login-user"
        v-model="form.userName"
        type="text"
        required
        placeholder="Felhasználónév"
      ></b-form-input>
      <b-form-input
        id="login-password"
        v-model="form.password"
        type="password"
        required
        placeholder="Jelszó"
      ></b-form-input>
      <b-button id="login-button" @click="signIn()" type="button" variant="success">Belépés</b-button>
    </b-form>
  </div>
</template>

<script>
import { authenticate } from "../services/backendService"
import { mapActions } from "vuex"

export default {
  name: "Login",
  data() {
    return {
      form: {
        userName: "",
        password: ""
      }
    }
  },
  methods: {
    ...mapActions(["signUserIn"]),
    async signIn() {
      const base64EncodedCredentials = btoa(this.form.userName + ":" + this.form.password)
      try {
        const response = await authenticate(base64EncodedCredentials)
        this.signUserIn(base64EncodedCredentials)
        this.$router.push("/")
      } catch (err) {
        if (err.response.status == 401 && err.response.data.statusz_kod === 52) {
          this.$router.push({ name: 'forgottenPassword', params: { userName: this.form.userName } })
        } 
        else if (err.response.status == 401) {
          alert(err.response.data.statusz_uzenet)
          this.form.userName = ""
          this.form.password = ""
        }
      }
    }
  }
}
</script>

<style scoped>
#login-user,
#login-password {
  width: 300px;
  margin-bottom: 15px;
}

#login-button {
  width: 300px;
  font-weight: bold;
  font-size: 20px;
}
</style>
